<template>
  <v-main class="p-error-layout">
    <div class="p-page-wrapper">
      <header class="p-error-layout__header">
        <router-link class="p-logo-2" :to="{ name: 'home' }"></router-link>
        <p-locale-switcher></p-locale-switcher>
      </header>

      <slot/>

    </div>

    <v-footer app class="p-error-layout__footer">
      {{ $t('copyright', { year: currentYear }) }}
    </v-footer>
  </v-main>
</template>


<script>
import PLocaleSwitcher from '@/components/PLocaleSwitcher'

export default {
  components: {
    PLocaleSwitcher
  },


  computed: {
    currentYear () {
      return (new Date()).getFullYear()
    }
  }
}
</script>
